import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import Task from '../Task';

import './style.less';
import { Group } from '@/components/_common';
import { useColorScheme } from '@/contexts/ColorSchemeContextProvider';
import { GPActivityColumnItem } from '@/core/domain/visual-management/activities/activities.types';
import WorkOrderStatusTag from '@/components/_common/WorkOrderStatusTag';

interface Props {
  column: { color: string; name: string; id: string };
  tasks?: GPActivityColumnItem[];
  onScrollEnd: VoidFunction;
}

const Column: React.FC<Props> = ({ column, tasks, onScrollEnd }) => {
  const [colorScheme] = useColorScheme();

  return (
    <>
      <div
        className={`kanban-column ${colorScheme}`}
        onScroll={(ev) => {
          const target = ev.target as HTMLDivElement;

          const offsetHeight = target.scrollTop + target.clientHeight;

          if (target.scrollHeight - 100 <= offsetHeight && onScrollEnd) {
            onScrollEnd();
          }
        }}
      >
        <Group
          className="kanban-column-title"
          style={{
            backgroundColor: colorScheme === 'dark' ? '#3a3939' : '#F4F5F7',
          }}
        >
          <WorkOrderStatusTag color={column.color} label={column.name} />
        </Group>

        <Droppable droppableId={column.id}>
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              className="kanban-column-content"
              style={{
                backgroundColor: snapshot.isDraggingOver
                  ? colorScheme === 'dark'
                    ? '#353333'
                    : 'rgb(229 231 237)'
                  : colorScheme === 'dark'
                  ? '#3a3939'
                  : '#F4F5F7',
              }}
              ref={provided.innerRef}
            >
              {tasks?.map((task, index) => (
                <Task key={task.id} task={task} index={index} />
              ))}

              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    </>
  );
};

export default Column;
